<template>
  <div>
    <input
      ref="input"
      type="file"
      name="image"
      accept="image/*"
      @change="setImage"
    />

    <div class="row">
      <div class="col-md-6 text-center">
        <div class="img-cropper" v-if="imgSrc">
          <vue-cropper
            ref="cropper"
            :aspect-ratio="4 / 4"
            :src="imgSrc"
            preview=".preview"
            :key="vueCropKey"
          />
        </div>
        <div v-else>
          <a-avatar v-if="student.photo" shape="square" :size="250" :src="student.photo" />
          <a-avatar v-else shape="square" :size="250" >No Image</a-avatar>
          <div class="my-3 d-flex flex-column align-items-center">
            <button class="btn btn-outline-primary mb-2"
              @click.prevent="showFileChooser"
            >
              <i class="mr-2 fe fe-upload" /> Upload from Computer
            </button>
            <button v-if="student.photo" class="btn btn-outline-danger"
              @click.prevent="handleRemovePhoto"
            >
              <i class="mr-2 fe fe-trash-2" /> Remove Photo
            </button>
          </div>
        </div>

        <div class="my-3" v-if="imgSrc">
          <div class="btn-group flex-wrap" role="group">
            <button type="button" class="btn btn-dark mb-1"
            ref="flipX"
            @click.prevent="flipX"
            :disabled="!imgSrc"
            >
              Flip X
            </button>
            <button type="button" class="btn btn-dark mb-1"
            @click.prevent="reset"
            :disabled="!imgSrc"
            >
              <i class="mr-2 fe fe-refresh-cw" /> Reset
            </button>
            <button type="button" class="btn btn-dark mb-1"
             @click.prevent="showFileChooser"
             :disabled="!imgSrc"
            >
              <i class="mr-2 fe fe-camera" /> Upload from Computer
            </button>
            <button v-if="student.photo" type="button" class="btn btn-danger mb-1"
              @click.prevent="handleRemovePhoto"
            >
              <i class="mr-2 fe fe-trash-2" /> Remove Photo
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-6 text-center" v-if="imgSrc">
        <div class="preview-area">
          <div class="row">
            <div class="col-12 text-center bg-light pt-3 pb-2">
              <div class="d-flex flex-column align-items-center">
                <p class="font-weight-bold text-muted">Preview</p>
                <div class="preview mb-3"/>
              </div>
            </div>
            <!-- <div class="col-6 text-center">
              <p class="font-weight-bold text-muted">Cropped Image</p>
              <div class="cropped-image">
                <img
                  v-if="cropImg"
                  :src="cropImg"
                  alt="Cropped Image"
                />
                <div v-else class="crop-placeholder bg-light" />
              </div>
            </div> -->
            <div class="col-12 text-center my-3">
              <button v-if="imgSrc" class="btn btn-success mr-2"
                @click.prevent="handleSubmit"
                :disabled="!imgSrc"
              >
                <i :class="['mr-2 fe fe-save']" /> Crop & Save Photo
              </button>
              <button v-if="imgSrc" class="btn btn-outline-danger"
                @click.prevent="handleCancel"
              >
                <i class="mr-2 fe fe-x" /> Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'

const options = {
  showLeafArrayIndexes: true,
  includeNullValues: false,
  mapping: function(value) {
    return value
  },
}

export default {
  props: ['image', 'student'],
  components: {
    VueCropper,
  },
  data() {
    return {
      cropImg: '',
      imgSrc: '',
      vueCropKey: 0,
    }
  },
  computed: {
    ...mapState(['settings']),
  },
  watch: {
    image: function(image) {
      this.imgSrc = image
      this.cropImg = ''
      this.vueCropKey += 1
    },
  },
  methods: {
    cropImage() {
      // get image data scaled down to max 600x600 JPEG at 0.8 quality
      if (this.$refs.cropper) {
        this.cropImg = this.$refs.cropper
          .getCroppedCanvas({
            width: 600,
            height: 600,
            imageSmoothingEnabled: true,
            imageSmoothingQuality: 'high',
          })
          .toDataURL('image/jpeg', 0.8)
      }
    },
    flipX() {
      const dom = this.$refs.flipX
      let scale = dom.getAttribute('data-scale')
      scale = scale ? -scale : -1
      this.$refs.cropper.scaleX(scale)
      dom.setAttribute('data-scale', scale)
    },
    reset() {
      this.$refs.cropper.reset()
      this.cropImg = ''
    },
    setImage(e) {
      const file = e.target.files[0]
      if (file.type.indexOf('image/') === -1) {
        alert('Please select an image file')
        return
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader()
        reader.onload = (event) => {
          this.imgSrc = event.target.result
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result)
        }
        reader.readAsDataURL(file)
      } else {
        alert('Sorry, FileReader API not supported')
      }
    },
    showFileChooser() {
      this.$refs.input.click()
    },
    handleCancel() {
      this.imgSrc = null
      this.cropImg = ''
      this.vueCropKey += 1
      // Reset the file input so the same file can be re-selected
      if (this.$refs.input) {
        this.$refs.input.value = ''
      }
    },
    handleRemovePhoto() {
      this.$confirm({
        title: 'Remove Student Photo?',
        content: 'Are you sure you want to remove this student photo?',
        okText: 'Yes, Remove',
        okType: 'danger',
        onOk: () => {
          this.$http
            .delete(`/api/upload_photo/student/${this.student.id}`)
            .then(() => {
              this.imgSrc = null
              this.cropImg = null
              this.$emit('updated')
              this.$notification['success']({
                message: 'Successfully removed',
                description: 'Student photo removed successfully!',
              })
            })
            .catch(error => {
              this.$neoNotify.error(error)
            })
        },
      })
    },
    handleSubmit () {
      this.cropImage()
      if (this.cropImg) {
        this.$confirm({
          title: `Save Student Photo?`,
          content: `Click on the OK button to update student photo!`,
          onOk: () => {
            // Get student Photo
            let photoFile = this.cropImg

            const values = {}

            let formData = window.jsonToFormData(values, options)

            formData.append('photo', photoFile)

            this.$http
              .post(`/api/upload_photo/student/${this.student.id}`, formData)
              .then(({ data }) => {
                this.$emit('updated')
                this.imgSrc = null
                this.cropImg = null
                this.loading = false
                this.visible = false
                this.$notification['success']({
                  message: 'Successfully uploaded',
                  description: `Student photo uploaded successfully!`,
                })
              })
              .catch(error => {
                this.loading = false
                this.$neoNotify.error(error)
              })
          },
          onCancel: () => {
            this.loading = false
          },
        })
      }
    },
  },

}
</script>

<style>
  input[type="file"] {
    display: none;
  }
  .cropper-area {
    width: 100%;
  }
  .preview-area {
    width: 100%;
  }
  .preview {
    width: 100%;
    /* height: calc(256px * (4 / 4)); */
    height: 200px;
    overflow: hidden;
  }
  .crop-placeholder {
    width: 100%;
    height: 164px;
  }
  .cropped-image img {
    max-width: 100%;
  }
</style>
